import axiosNest from '../../api/axiosNest';

/**
 * „Jestem opiekunem FTL” — wywołania API
 * (`apps/api/src/ftl-caretakers/ftl-caretakers.controller.ts`).
 *
 * Preferencja do przełącznika „Tylko moje pojazdy” — filtr dla wygody,
 * NIE uprawnienie (status 29.09.2026). Każdy nadal widzi całą flotę.
 */

export const CARETAKERS_URL = '/ftl-caretakers';

export interface CaretakerPreference {
  /** Opiekun FTL wskazany przez użytkownika; `null` = nie ustawione. */
  caretaker: string | null;
  /** Opiekunowie z kartoteki aut — do wyboru. */
  caretakers: string[];
}

export async function fetchCaretakerPreference(): Promise<CaretakerPreference> {
  const { data } = await axiosNest.get<CaretakerPreference>(`${CARETAKERS_URL}/me`);
  return {
    caretaker: typeof data?.caretaker === 'string' ? data.caretaker : null,
    caretakers: Array.isArray(data?.caretakers) ? data.caretakers : [],
  };
}

export async function saveCaretakerPreference(caretaker: string | null): Promise<string | null> {
  const { data } = await axiosNest.put<{ caretaker: string | null }>(`${CARETAKERS_URL}/me`, {
    caretaker,
  });
  return data?.caretaker ?? null;
}
